export const vatAuditsTableFields = [
	{ key: 'created_at', label: 'Date Sent' },
	{ key: 'event', label: 'Event' },
	{ key: 'from', label: 'From' },
	{ key: 'to', label: 'To' },
	{ key: 'user.name', label: 'By' },
];
